import { IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonChip, IonCol, IonContent, IonDatetime, IonGrid, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonItem, IonLabel, IonLoading, IonModal, IonPage, IonPopover, IonRefresher, IonRefresherContent, IonRow, IonSegment, IonSegmentButton, IonSelect, IonSelectOption, IonTitle, IonToast, IonToolbar, isPlatform, useIonAlert, useIonToast, useIonViewDidEnter } from '@ionic/react';
import { Buffer } from 'buffer';
import { albums, arrowBack, chatbox, documentOutline, logoUsd, power, printOutline, search } from 'ionicons/icons';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { imprimirCupomComFallbackData } from '../../../../../Utils/EscPosGenerator';
import { adicionarImpressaoNaFila, criarJobImpressao } from '../../../../../Utils/PrintQueueHelper';
import { alterarStatusProjeto, listaEquipePorPerfil, projetoGerarAcompanhamento, projetoGerarCupom, projetoGerarCupomPdf, reabrirProjeto, requestService, urlBaseCore } from '../../../../../Utils/Services';
import AppTypeaheadItem from '../../../../../components/AppTypeaheadItem';
import { MessageContext } from '../../../../../contexts/MessageContext';
import './OrdensHistorico.css';

const OrdensHistorico: React.FC = () => {
  const history = useHistory();
  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");
  const [arrayProjetos, setArrayProjetos] = useState<any>([]);
  const [projetoId, setProjetoId] = useState("");
  const [desabilitarInfiniteScroll, setDesabilitarInfiniteScroll] = useState(false);
  const [projetopk, setProjetopk] = useState("");
  const [projetosk, setProjetosk] = useState("");
  const [projetogsi2sk, setProjetogsi2sk] = useState("");
  const [showCopiado, setShowCopiado] = useState(false);
  const [listaClientesFiltro, setListaClientesFiltro] = useState<any>([]);
  const [pesquisaData, setPesquisaData] = useState<any>("Pesquisar");
  const [pesquisaNome, setPesquisaNome] = useState<any>("Pesquisar");
  const [showLoadingPage, setShowLoadingPage] = useState(true);
  const [showModalData, setShowModalData] = useState(false);
  const popover = useRef<HTMLIonPopoverElement>(null);
  const contentRef = useRef<HTMLIonContentElement | null>(null);
  const [mostartAlerta] = useIonAlert();
  const [mostrarToast, fecharToast] = useIonToast();
  const [showDetalhesConvidado, setShowDetalhesConvidado] = useState(false);
  const [tipo, setTipo] = useState<any>();
  const [showDetalhesParceria, setShowDetalhesParceria] = useState(false);
  const { loja, setLoja } = useContext(MessageContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const [showNovoAgendamento, setShowNovoAgendamento] = useState(false);
  const [showModalFiltro, setShowModalFiltro] = useState(false);
  const [showModalServicoProduto, setShowModalServicoProduto] = useState(false);
  const { filtroCampoSelecionadoProjeto, setFiltroCampoSelecionadoProjeto } = useContext(MessageContext);
  const { filtroMostrarDataProjeto, setFiltroMostrarDataProjeto } = useContext(MessageContext);
  const { filtroPesquisaProjeto, setFiltroPesquisaProjeto } = useContext(MessageContext);
  const { filtroStatusProjeto, setFiltroStatusProjeto } = useContext(MessageContext);
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);
  const [showEncerrar, setShowEncerrar] = useState(false);
  const inputConvidadosRef = useRef<any>(null);
  const [selectedSegment, setSelectedSegment] = useState('');

  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);

  useEffect(() => {
    // primeira vez q entra e quando troca de loja
    console.log("entrou useEffect mudou loja - projetos", loja);
    console.log("entrou useEffect mudou loja - projetos", filtroStatusProjeto);
    setFiltroCampoSelecionadoProjeto("data");
    setFiltroMostrarDataProjeto(true);
    setFiltroStatusProjeto("Encerrado");
    // setRecarregarProjeto(false);
    carregarProjetosSegmentadaData("Encerrado", "");
    setPesquisaData('Pesquisar');
  }, []
  );

  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu(window.localStorage.getItem("servicoTipoPlural") || "Projetos");
  })

  const filtroSelectionChanged = (filtroClientes: string) => {

    if (filtroClientes != "") {
      setFiltroPesquisaProjeto(filtroClientes);
      const cliente = listaClientesFiltro.find((prospect: any) => prospect.pk === filtroClientes);
      setPesquisaNome(cliente.nome);
    }
    else {
      setFiltroPesquisaProjeto("");
      setPesquisaNome("Pesquisar");
    }
    carregarProjetosSegmentadaData(filtroStatusProjeto, filtroClientes);
    setShowModalFiltro(false);
  };

  async function lerCLientesFiltro() {


    let token: string = "";
    const tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") {
      token = tkn;
    }

    let montarUrl = listaEquipePorPerfil.url.replace("{loja}", loja.replaceAll(/#/g, "%23"));//.concat("?status=ativo");

    console.log("lojas", loja);
    setShowLoadingPage(true);
    const resp = await fetch(montarUrl.replace("{perfil}", "cliente"),
      {
        method: "GET",
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });

    let equipe = await resp.json();
    setShowLoadingPage(false);
    if (resp.status === 400 || resp.status === 401) {
      history.replace("/login/");
    }
    else {
      let lista = (equipe.Items.sort((a: any, b: any) => (a.nome.toLowerCase() > b.nome.toLowerCase()) ? 1 : -1))
      setListaClientesFiltro(lista);
    }

  }

  function trocarCampoFiltro(e: any) {
    setFiltroCampoSelecionadoProjeto(e.detail.value);

    if (e.detail.value === 'data') {
      console.log('entrou data');
      setFiltroMostrarDataProjeto(true);


    }
    else {
      console.log('entrou nome');
      lerCLientesFiltro();
      setFiltroMostrarDataProjeto(false);

    }
    setPesquisaNome("Pesquisar");
    setPesquisaData("Pesquisar");
    setFiltroPesquisaProjeto("");
    setArrayProjetos([]);
  }

  function doRefresh(event: any) {
    carregarProjetosSegmentadaData(filtroStatusProjeto, filtroPesquisaProjeto);
    setTimeout(() => {
      event.detail.complete();
    }, 1200);
  }

  function carregarDetalhes(projetoid: any, abrirInserirAgendamento: boolean) {
    history.push("ordens/ordensdetalhes", { projetoid: projetoid, abrirInserirAgendamento: abrirInserirAgendamento })
  }

  function carregarWorkflow(configsLoja: any, projetoid: any) {
    history.push("ordens/ordensworkflow", { projetoid: projetoid })

  }

  function carregarServicos(projetoid: any) {
    history.push("ordens/ordensservicos", { id: projetoid.replaceAll(/#/g, "%23") })

  }

  function carregarProdutos(projetoid: any) {
    history.push("ordens/ordensprodutos", { id: projetoid.replaceAll(/#/g, "%23") })

  }

  function converterParaString(dadosImpressao: any) {
    return String.fromCharCode(...dadosImpressao.filter((byte: any) => byte <= 0xFF)); // Filtrando valores válidos
  }

  async function enviarImpressao(printer: any, data: any) {

    const url = "http://localhost:9100/print";

    // Montando o corpo da requisição no formato necessário
    var raw = JSON.stringify({
      "printer": printer,
      "data": data,  // Dados no formato correto (com códigos ESC/POS)
    });

    try {
      // Configurações da requisição
      const requestOptions: any = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: 'follow',
      };

      // Envia a requisição utilizando fetch
      const resp = await fetch(url, requestOptions);

      // Aguardar a resposta como texto
      const result = await resp.text();

      if (result) {
        console.log("Impressão enviada com sucesso:", result);
      } else {
        console.error("Erro: Nenhuma resposta recebida.");
      }
    } catch (error) {
      console.error("Erro ao enviar dados para a impressora:", error);
    }
  }

  async function gerarCupom(projetoid: any) {


    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }
    console.log("projetoid", projetoid);

    try {
      setShowLoadingPage(true);
      const impresso = await imprimirCupomComFallbackData({
        projetoid,
        dadosEmpresa,
        origem: 'OrdensHistorico:gerarCupom'
      });
      if (impresso) return;
    } catch (error) {
      console.error("Erro ao imprimir cupom pela fila:", error);
    } finally {
      setShowLoadingPage(false);
    }

    setShowLoadingPage(true);
    const resp = await fetch(projetoGerarCupom.url.replaceAll("{id}", projetoid.replaceAll(/#/g, "%23")),
      {
        method: projetoGerarCupom.method,
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
    const result = await resp.json();
    if (result) {
      console.log("result", result);

      mostartAlerta({
        backdropDismiss: false,
        header: 'Gerar Cupom',
        message: '<strong>Cupom</strong> foi gerado com sucesso.',
        buttons: [
          {
            text: 'Cancelar',
            role: 'cancel',
          },
          {
            text: 'Visualizar',
            cssClass: 'primary',
            handler: () => {
              window.open(result, '_blank');
            }
          }
        ],
        onDidDismiss: (e) => console.log('did dismiss'),
      })

    }

    setShowLoadingPage(false);

  }

  async function gerarCupomPdf(projetoid: any) {


    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }
    console.log("projetoid", projetoid);

    setShowLoadingPage(true);
    const resp = await fetch(projetoGerarCupomPdf.url.replaceAll("{id}", projetoid.replaceAll(/#/g, "%23")),
      {
        method: projetoGerarCupomPdf.method,
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
    const result = await resp.json();
    if (result) {
      console.log("result", result);

      mostartAlerta({
        backdropDismiss: false,
        header: 'Gerar Cupom PDF',
        message: '<strong>Cupom PDF</strong> foi gerado com sucesso.',
        buttons: [
          {
            text: 'Cancelar',
            role: 'cancel',
          },
          {
            text: 'Visualizar',
            cssClass: 'primary',
            handler: () => {
              window.open(result, '_blank');
            }
          }
        ],
        onDidDismiss: (e) => console.log('did dismiss'),
      })

    }

    setShowLoadingPage(false);

  }

  async function gerarAcompanhamento(projetoid: any) {


    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }
    console.log("projetoid", projetoid);

    setShowLoadingPage(true);
    const resp = await fetch(projetoGerarAcompanhamento.url.replaceAll("{id}", projetoid.replaceAll(/#/g, "%23")),
      {
        method: projetoGerarAcompanhamento.method,
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
    const result = await resp.json();
    if (result) {
      console.log("result", result);

      mostartAlerta({
        backdropDismiss: false,
        header: 'Gerar PDF',
        message: '<strong>PDF</strong> foi gerado com sucesso.',
        buttons: [
          {
            text: 'Cancelar',
            role: 'cancel',
          },
          {
            text: 'Visualizar',
            cssClass: 'primary',
            handler: () => {
              window.open(result, '_blank');
            }
          }
        ],
        onDidDismiss: (e) => console.log('did dismiss'),
      })

    }

    setShowLoadingPage(false);

  }

  function formataTelefone(numero: any) {
    if (numero?.length == 13) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{5})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else if (numero?.length == 12) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{4})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else { return "" };
  }

  function alterarStatus(pk: any, interno: boolean) {
    setShowLoadingPage(true);
    requestService(alterarStatusProjeto.url.replaceAll("{id}", pk.replaceAll(/#/g, "%23") + "?interno=" + interno), {
      method: alterarStatusProjeto.method,
      headers: [
        ["token", window.localStorage.getItem("token")]
      ],
      credentials: 'include'
    },
      history,
      (response: any) => {
        console.log(response);
        carregarProjetosSegmentadaData(filtroStatusProjeto, filtroPesquisaProjeto);
      },
      (error: any) => {
        console.log(error);
        history.replace("/login/");
      }).finally(() => {
        setShowLoadingPage(false);
      });
  }
  const getColor = (percentual: any) => {
    const percent = parseFloat(percentual?.toString().replace(/\./g, '').replace(/\,/g, '.') || 0);
    if (percent <= 33) {
      return "rgba(212, 37, 28, 0.5)"; // Vermelho com 70% de opacidade
    } else if (percent <= 66) {
      return "rgba(29, 52, 96, 0.5)"; // Azul com 70% de opacidade
    } else {
      return "rgba(51, 172, 27, 0.5)"; // Verde com 70% de opacidade
    }
  };

  function preencheCard(value: any, indice: any) {
    return (
      <IonCard className={"cardProjeto"} key={"projeto" + indice + value.pk}>
        <IonCardHeader id={value.pk} style={{ margin: 0 }}>
          <div className="tempo2">
            <div className="duracao">
              <IonLabel>{(value.statusWorkflow)}</IonLabel>
            </div>
          </div>
          <IonItem style={{ width: "100%", borderRadius: "10px 10px 0 0" }} lines="none" detail={true} onClick={() => {
            carregarDetalhes(value.pk.replaceAll(/#/g, '%23'), false);
          }} button>
            <IonLabel style={{ margin: 0 }} slot="start">
              {(window.localStorage.getItem("servicoTipo") || "Projeto") + " - " + value.nomeProjeto}
            </IonLabel>
            <IonLabel style={{ margin: 0 }} slot='end'>detalhes</IonLabel>
          </IonItem>
        </IonCardHeader>
        <IonCardContent>
          <IonGrid>
            <IonRow key={"projetorow1" + indice + value.pk}>
              <IonCol>
                <div className="projeto">
                  {/* <IonLabel position="fixed" hidden={acessos?.projetos != 'edicao'}>
                    {
                      value.gsi4sk?.substr(-7) == "interno" ?
                        <IonIcon color="danger" icon={lockClosed}
                          onClick={() => {
                            alterarStatus(value.pk, false);
                          }} /> :
                        <IonIcon color="success" icon={lockOpen}
                          onClick={() => {
                            alterarStatus(value.pk, true);
                          }} />
                    } Cliente</IonLabel> */}
                  <IonLabel className="operacaoTexto">Cliente</IonLabel>

                  <IonLabel className="projetoTexto">{value.clienteNome}</IonLabel>


                  <IonIcon id="icone-chatbox" color="primary" icon={chatbox} hidden={value.clienteInterno}
                    onClick={(e) => {
                      history.push("ordens/mensagem", { projetoid: value.pk.replaceAll(/#/g, '%23'), projetonome: value.nomeProjeto });
                      //carregarVenda(value.vendaid.replaceAll(/#/g, '%23'), value.gsi2pk.replaceAll(/#/g, '%23'));
                    }} />
                  {/* {
                    acessos?.vendas == 'leitura' || acessos?.vendas == 'edicao' ?
                      value.vendaid ?
                        <IonIcon color="primary" icon={trendingUp}
                          onClick={(e) => {
                            carregarVenda(value.vendaid.replaceAll(/#/g, '%23'), value.gsi2pk.replaceAll(/#/g, '%23'));
                          }} /> :
                        <></>
                      : <></>
                  } */}

                </div>
                <div className="projeto">
                  <IonLabel></IonLabel>
                  <IonLabel className="projetoTexto"> <div>
                    <a target='_blank' href={'https://api.whatsapp.com/send?phone=' + value.clienteTelefone}>
                      <p style={{ color: "black" }}><b>{formataTelefone(value.clienteTelefone)}</b></p>
                    </a>
                  </div></IonLabel>
                </div>
              </IonCol>
            </IonRow>

            <IonRow>
              <IonCol key={"projetorow4" + indice + value.pk}>
                <div className="operacao">
                  <IonLabel position="fixed">{window.localStorage.getItem("nomeLinhaDoTempo") || "Linha do tempo"}</IonLabel>

                  {value.layoutSimplificado ?
                    <IonLabel className="operacaoTexto">{value.statusWorkflow}</IonLabel>
                    :
                    <IonChip slot="end" color='primary' style={{ padding: "7px", margin: "0px", fontWeight: 'bold', fontSize: "24px" }} onClick={(e) => {
                      carregarWorkflow(value.configWorkflow, value.pk.replaceAll(/#/g, '%23'));
                    }}>
                      <IonIcon icon={albums} style={{ height: "20px" }}></IonIcon>
                      <IonLabel style={{ width: "auto" }}
                        className="ion-text-wrap">{value.statusWorkflow}</IonLabel>
                    </IonChip>
                  }
                </div>
              </IonCol>
            </IonRow>

            <IonRow hidden={window.localStorage.getItem("esconderValoresProjeto") == "true" || window.localStorage.getItem("servicoPrincipal") != "Pedidos"}>
              <IonCol key={"projetorow5" + indice + value.pk}>
                <div className="operacao">
                  <IonLabel position="fixed">Itens</IonLabel>


                  <IonChip slot="end" color='primary' style={{ padding: "7px", margin: "0px", fontWeight: 'bold', fontSize: "24px" }} onClick={(e) => {
                    carregarProdutos(value.pk);
                  }}>
                    <IonIcon icon={logoUsd} style={{ height: "20px" }}></IonIcon>
                    <IonLabel style={{ width: "auto" }}
                      className="ion-text-wrap">{value.valorTotalProdutos || "0,00"}</IonLabel>
                  </IonChip>

                </div>
              </IonCol>
            </IonRow>

            <IonRow hidden={window.localStorage.getItem("esconderValoresProjeto") == "true" || window.localStorage.getItem("servicoPrincipal") == "Pedidos"}>
              <IonCol key={"projetorow6" + indice + value.pk}>
                <div className="operacao">
                  <IonLabel position="fixed">Itens</IonLabel>


                  <IonChip slot="end" color='primary' style={{ padding: "7px", margin: "0px" }} onClick={(e) => {
                    carregarServicos(value.pk);
                  }}>
                    <IonIcon icon={logoUsd} style={{ height: "20px" }}></IonIcon>
                    <IonLabel style={{ width: "auto" }}
                      className="ion-text-wrap">{value.valorTotalServicos || "0,00"}</IonLabel>
                  </IonChip>

                </div>
              </IonCol>
            </IonRow>

            <IonRow hidden={!(value.servicos?.length > 0)}>

              <IonCol key={"projetorow7" + indice + value.pk}>
                <div className="operacao">

                  <IonLabel position="fixed">Status</IonLabel>

                  <div onClick={(e) => {
                    carregarServicos(value.pk);
                  }} style={{
                    position: "relative", height: "32px", width: "100%", backgroundColor: "#f5f5f5",
                    borderRadius: "20px"
                  }}>
                    <div
                      style={{
                        position: "absolute",
                        top: "0",
                        left: "0",
                        height: "100%",
                        width: `${parseFloat(value.percentualTotalServicos?.toString().replace(/\./g, '').replace(/\,/g, '.') || 0)}%`,
                        backgroundColor: getColor(value.percentualTotalServicos),
                        zIndex: "1",
                        borderRadius: "20px",
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: "2"
                      }}
                    >
                      {value.percentualTotalServicos || "0"}%
                      {/* {value.layoutSimplificado ?
                        <IonLabel className="operacaoTexto">{value.statusWorkflow}</IonLabel>
                        :
                        <IonLabel className="operacaoTexto" onClick={(e) => {
                          carregarWorkflow(value.configWorkflow, value.pk.replaceAll(/#/g, '%23'));
                        }}>{value.statusWorkflow} </IonLabel>

                      } */}
                    </div>
                  </div>

                </div>
              </IonCol>
            </IonRow>

            <IonRow key={"projetorow3" + indice + value.pk}>
              <IonCol>
                <div className="operacao">
                  <IonLabel position="fixed">Anotações</IonLabel>
                </div>
                <div className="operacao">
                  <IonLabel key={"projetolabel" + indice + value.pk} className="operacaoTexto" style={{ margin: 0 }}>
                    {
                      value.anotacoes?.sort(function (a: any, b: any) {
                        if (a.data < b.data) {
                          return 1;
                        }
                        if (a.data > b.data) {
                          return -1;
                        }
                        return 0;
                      }).slice(0, 5).map((anotacoesValue: any) => (
                        <p key={"projetop" + indice + value.pk + anotacoesValue.data} style={{ color: "#000000", fontSize: "12px" }}><b>{new Date(anotacoesValue.data).toLocaleDateString() + " " + new Date(anotacoesValue.data).toLocaleTimeString()}</b> - {anotacoesValue.anotacao}</p>
                      ))}
                  </IonLabel>
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>

          <IonItem lines="none">

            <IonChip slot="end" color='primary' hidden={(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas")}
              onClick={async (e) => {
                await gerarAcompanhamento(value.pk);
              }}>
              <IonIcon icon={documentOutline}></IonIcon>
              <IonLabel>Gerar PDF</IonLabel>
            </IonChip>




            <IonChip style={{ fontSize: "18px", borderRadius: '8px' }} hidden={!(window.localStorage.getItem("servicoPrincipal") == "Pedidos" || window.localStorage.getItem("servicoPrincipal") == "Vendas")} slot="end" color='primary' onClick={async () => {

              setProjetoId(value.pk);

              // === NOVO: SISTEMA DE FILA DE IMPRESSÃO ===
              const comandosEscPos = gerarEscPos(value, (dadosEmpresa.impressoraLargura == "58" ? true : false));
              if (comandosEscPos) {
                const mobile = !isPlatform('mobileweb') && isPlatform('mobile');

                let tipo: 'ble' | 'spp' | 'rede' | 'local' | null = null;
                let config: any = {};

                if (impressoraRedeHabilitar() && mobile) {
                  tipo = 'rede';
                  config = { ip: dadosEmpresa.impressoraRedeIp, porta: dadosEmpresa.impressoraRedePorta };
                } else if (impressoraLocalHabilitar() && !mobile) {
                  tipo = 'local';
                  config = { printerName: window.localStorage.getItem("impressoraLocalName") || "" };
                } else if (impressoraBluetoothHabilitar() && mobile) {
                  tipo = 'ble';
                  config = { deviceId: window.localStorage.getItem("impressoraBluetoothDeviceId") };
                } else if (impressoraBluetoothSPPHabilitar() && isPlatform('android') && mobile) {
                  tipo = 'spp';
                  config = { address: window.localStorage.getItem("impressoraBluetoothSPPAddress") };
                }

                if (tipo) {
                  const adicionado = adicionarImpressaoNaFila(criarJobImpressao({
                    comandosEscPos,
                    dados: value,
                    impressoraConfig: config,
                    tipo,
                    quantidadeVias: 1,
                    origem: 'OrdensHistorico:cardButton'
                  }));

                  if (adicionado) {
                    console.log('📋 [HISTORICO] Cupom adicionado na fila');
                    return; // Sucesso - não executar código legado
                  }
                }
              }
              // === FIM DO SISTEMA DE FILA ===

              // if (dadosEmpresa.impressoraRedeHabilitar && (!isPlatform('mobileweb') && isPlatform('mobile'))) {
              //   const ipImpressora = dadosEmpresa.impressoraRedeIp;
              //   const portaImpressora = dadosEmpresa.impressoraRedePorta;

              //   const conectarEEnviar = () => {
              //     // Cria o socket TCP
              //     window.chrome.sockets.tcp.create({}, (createInfo) => {
              //       const socketId = createInfo.socketId;

              //       // Define o timeout para mostrar a mensagem de erro após 3 segundos
              //       const timeoutId = setTimeout(() => {
              //         setTextToast("Erro ao conectar.");
              //         setShowToast(true);
              //         window.chrome.sockets.tcp.close(socketId);
              //       }, 3000); // 3 segundos

              //       // Tenta conectar ao IP e porta especificados
              //       window.chrome.sockets.tcp.connect(socketId, ipImpressora, portaImpressora, (result) => {
              //         if (result === 0) {
              //           // Conexão bem-sucedida, cancela o timeout
              //           clearTimeout(timeoutId);

              //           console.log('Conexão bem-sucedida! Enviando dados...');

              //           const comandosEscPos = gerarEscPos(value, (dadosEmpresa.impressoraLargura == "58" ? true : false));
              //           if (comandosEscPos) {
              //             window.chrome.sockets.tcp.send(socketId, comandosEscPos.buffer, (sendInfo) => {
              //               console.log('Comando enviado com sucesso:', sendInfo);
              //               window.chrome.sockets.tcp.close(socketId);
              //             });
              //           } else {
              //             console.error('Erro ao gerar ESC/POS');
              //           }
              //         } else {
              //           // Conexão falhou, cancela o timeout e mostra mensagem de erro
              //           clearTimeout(timeoutId);
              //           console.error(`Erro ao conectar à impressora. Verifique a conexão.`);
              //           setTextToast("Erro ao conectar.");
              //           setShowToast(true);
              //           window.chrome.sockets.tcp.close(socketId);
              //         }
              //       });
              //     });
              //   };


              //   // Chame a função com o URL do HTML que você deseja imprimir
              //   conectarEEnviar();
              // }
              // else if (impressoraLocalHabilitar() && !(!isPlatform('mobileweb') && isPlatform('mobile'))) {

              //   console.log("*********************impressao browser pela rede");

              //   const conectarEEnviar = () => {
              //     // Cria o socket TCP


              //     console.log('Conexão bem-sucedida! Enviando dados...');

              //     const comandosEscPos: any = gerarEscPos(value, (dadosEmpresa.impressoraLargura == "58" ? true : false));

              //     if (comandosEscPos) {
              //       // Exemplo de uso
              //       const resultadoString = converterParaString(comandosEscPos);
              //       // const resultadoString = arrayToEscapedString(comandosEscPos);
              //       //console.log(resultadoString);




              //       const printerName = window.localStorage.getItem("impressoraLocalName") || "";

              //       enviarImpressao(printerName, resultadoString);




              //     } else {
              //       console.error('Erro ao gerar ESC/POS');
              //     }

              //   };


              //   // Chame a função com o URL do HTML que você deseja imprimir
              //   conectarEEnviar();


              // }
              // else if (impressoraBluetoothHabilitar() && (!isPlatform('mobileweb') && isPlatform('mobile'))) {
              //   const comandosEscPos = gerarEscPos(value, (dadosEmpresa.impressoraLargura == "58" ? true : false));
              //   if (comandosEscPos) {
              //     const PRINT_SERVICE_UUID = "000018f0-0000-1000-8000-00805f9b34fb";
              //     const PRINT_CHARACTERISTIC_UUID = "00002af1-0000-1000-8000-00805f9b34fb";
              //     // Fragmentar os dados em pacotes menores
              //     const chunkSize = 20; // Tamanho máximo permitido por pacote BLE
              //     const buffer = comandosEscPos.buffer;

              //     const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

              //     // Verificar e conectar se necessário (contingência)
              //     const impressoraBluetoothDeviceId = window.localStorage.getItem("impressoraBluetoothDeviceId");
              //     if (!impressoraBluetoothDeviceId) {
              //       console.error("Device ID da impressora não encontrado");
              //       setTextToast("Erro: impressora não configurada.");
              //       setShowToast(true);
              //       return;
              //     }

              //     let isConnected = false;
              //     try {
              //       const connectedDevices = await BleClient.getConnectedDevices([]);
              //       isConnected = connectedDevices.some(device => device.deviceId === impressoraBluetoothDeviceId);
              //       console.log("BLE já conectado:", isConnected);
              //     } catch (checkError) {
              //       console.error("Erro ao verificar conexão BLE:", checkError);
              //       isConnected = false;
              //     }

              //     if (!isConnected) {
              //       try {
              //         console.log("Conectando à impressora BLE...");
              //         await BleClient.connect(impressoraBluetoothDeviceId);
              //         await delay(1000); // Aguardar estabilização da conexão
              //         console.log("Conectado à impressora BLE");
              //       } catch (connectError) {
              //         console.error("Erro ao conectar à impressora BLE:", connectError);
              //         setTextToast("Erro ao conectar à impressora BLE.");
              //         setShowToast(true);
              //         return;
              //       }
              //     }

              //     try {
              //       // Loop para enviar os dados em pacotes
              //       for (let i = 0; i < buffer.byteLength; i += chunkSize) {
              //         const chunk = new DataView(buffer.slice(i, Math.min(i + chunkSize, buffer.byteLength)));
              //         await BleClient.write(
              //           impressoraBluetoothDeviceId,
              //           PRINT_SERVICE_UUID,
              //           PRINT_CHARACTERISTIC_UUID,
              //           chunk
              //         );
              //         await delay(50); // Atraso de 50ms entre os envios
              //       }

              //       setTextToast("Impressão realizada com sucesso!");
              //       setShowToast(true);

              //     } catch (error) {
              //       console.error("Erro durante a impressão BLE:", error);
              //       setTextToast("Erro ao realizar a impressão.");
              //       setShowToast(true);
              //       // Não desconectar aqui - manter a conexão para próximas tentativas
              //     }
              //   } else {
              //     console.error('Erro ao gerar ESC/POS');
              //   }
              // }
              // else if (impressoraBluetoothSPPHabilitar() && isPlatform('android') && (!isPlatform('mobileweb') && isPlatform('mobile'))) {
              //   // Impressão via SPP (Serial Port Profile) - Android apenas
              //   const comandosEscPos = gerarEscPos(value, (dadosEmpresa.impressoraLargura == "58" ? true : false));
              //   if (comandosEscPos) {
              //     const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

              //     // Verificar e conectar se necessário (contingência SPP)
              //     const impressoraBluetoothSPPAddress = window.localStorage.getItem("impressoraBluetoothSPPAddress");
              //     if (!impressoraBluetoothSPPAddress) {
              //       console.error("Endereço SPP da impressora não encontrado");
              //       setTextToast("Erro: impressora SPP não configurada.");
              //       setShowToast(true);
              //       return;
              //     }

              //     let isConnected = false;
              //     try {
              //       isConnected = await BluetoothSerial.isConnected();
              //       console.log("SPP já conectado:", isConnected);
              //     } catch (checkError) {
              //       console.log("SPP não conectado, tentando conectar...");
              //       isConnected = false;
              //     }

              //     if (!isConnected) {
              //       try {
              //         console.log("Conectando à impressora SPP...");
              //         await new Promise<void>((resolve, reject) => {
              //           const timeout = setTimeout(() => {
              //             reject(new Error('Timeout ao conectar SPP'));
              //           }, 10000);

              //           BluetoothSerial.connect(impressoraBluetoothSPPAddress).subscribe(
              //             async () => {
              //               clearTimeout(timeout);
              //               console.log("Conectado à impressora SPP");
              //               await delay(1500); // Aguardar estabilização
              //               resolve();
              //             },
              //             (error: any) => {
              //               clearTimeout(timeout);
              //               reject(error);
              //             }
              //           );
              //         });
              //       } catch (connectError) {
              //         console.error("Erro ao conectar à impressora SPP:", connectError);
              //         setTextToast("Erro ao conectar à impressora SPP.");
              //         setShowToast(true);
              //         return;
              //       }
              //     }

              //     try {
              //       // Converter comandos ESC/POS para string
              //       const dataString = converterParaString(comandosEscPos);

              //       await BluetoothSerial.write(dataString);
              //       console.log("Impressão SPP realizada com sucesso");

              //       setTextToast("Impressão SPP realizada com sucesso!");
              //       setShowToast(true);

              //     } catch (error) {
              //       console.error("Erro durante a impressão SPP:", error);
              //       setTextToast("Erro ao realizar a impressão SPP.");
              //       setShowToast(true);
              //       // Não desconectar aqui - manter a conexão para próximas tentativas
              //     }
              //   } else {
              //     console.error('Erro ao gerar ESC/POS para SPP');
              //   }
              // }
              // else {
              await gerarCupom(value.pk);
              // await openNewTabWithHTML(value);
              // }

            }}>

              <IonIcon icon={printOutline}></IonIcon>
              <IonLabel>Cupom</IonLabel>
            </IonChip>

          </IonItem>

          <IonItem style={{ padding: 0, margin: 0, "borderRadius": "10px" }} color="grey" lines='none' hidden={acessos?.projetos != 'edicao'}>
            <IonSegment value={selectedSegment} onIonChange={handleSegmentChange}>
              <IonSegmentButton hidden={value.status != "Encerrado"} style={{ height: "25px", padding: 0, margin: 0 }} color='primary' onClick={(e) => {
                mostartAlerta({
                  backdropDismiss: false,
                  header: 'Reabrir ' + (window.localStorage.getItem("servicoTipo") || "Projeto"),
                  message: 'Deseja <strong>reabrir</strong>?',
                  buttons: [
                    {
                      text: 'Cancelar',
                      role: 'cancel',
                    },
                    {
                      text: 'Confirmar',
                      cssClass: 'primary',
                      handler: () => {
                        setShowLoadingPage(true);
                        let retorno = reabrir2(value.pk);
                        if (retorno) {
                          retorno?.then(res => {
                            if (res.status === 200) {
                              value.pk = "zero";
                              mostrarToast({
                                duration: 2000,
                                position: 'middle',
                                buttons: [{ text: 'ok', handler: () => fecharToast() }],
                                message: (window.localStorage.getItem("servicoTipo") || "Projeto") + " reaberto com sucesso."
                              });
                            }
                            else {
                              mostrarToast({
                                position: 'middle',
                                buttons: [{ text: 'ok', handler: () => fecharToast() }],
                                message: 'Erro ao tentar reabrir.'
                              });
                            }
                          }).catch(() => {
                            mostrarToast({
                              position: 'middle',
                              buttons: [{ text: 'ok', handler: () => fecharToast() }],
                              message: 'Erro ao tentar cancelado.'
                            });
                          }).finally(() => {
                            carregarProjetosSegmentadaData(filtroStatusProjeto, filtroPesquisaProjeto);
                            setShowLoadingPage(false);
                          });
                          return true;
                        }
                        else {
                          mostrarToast({
                            position: 'middle',
                            buttons: [{ text: 'ok', handler: () => fecharToast() }],
                            message: 'Erro ao tentar fechar.'
                          });
                          setShowLoadingPage(false);
                          return false;
                        }
                      }
                    }
                  ],
                  onDidDismiss: (e) => console.log('did dismiss'),
                })
              }}>
                <IonIcon icon={power} color={"success"} style={{ padding: 0, margin: 0 }}></IonIcon>
                <IonLabel style={{ "fontSize": "8px", padding: 0, margin: 0 }}>Reabrir</IonLabel>
              </IonSegmentButton>

            </IonSegment>
          </IonItem>
        </IonCardContent>
      </IonCard >
    )
  }

  function reabrir2(projeto: string) {

    return fetch(reabrirProjeto.url.replace("{id}", projeto.replaceAll(/#/g, "%23")),
      {
        method: reabrirProjeto.method,
        headers: [
          ["token", localStorage.getItem("token") || ""]
        ],
        credentials: 'include'
      });
  }

  const loadItens = () => {

    if (arrayProjetos === undefined || arrayProjetos.length === 0) {
      return (
        <IonCard key="primeira">
          <IonCardHeader key="primeiraheader" >
            <IonCardTitle>Neste momento não existe {window.localStorage.getItem("servicoTipo") || "Projeto"}.</IonCardTitle>
            <IonCardSubtitle></IonCardSubtitle>
            <IonLabel></IonLabel>
          </IonCardHeader>
          <IonCardContent>
          </IonCardContent>
        </IonCard>
      )
    }

    return arrayProjetos.map((value: any, index: any, arr: any) =>

      (!arr[index - 1]) ?
        (<div key={"divprojetopai" + index}>
          <IonCard className={"card"} key={"projeto" + index}>
            <IonCardHeader key={"headerprojeto" + index}>
              <IonCardTitle key={"tituloprojeto" + index}>
                <div key={"divprojeto" + index} className={"cabecalho"} >{new Date(value.dataCadastro).toLocaleString('pt-BR').substring(0, 10)}</div>
              </IonCardTitle>
            </IonCardHeader>
          </IonCard>
          {preencheCard(value, index)}
        </div>)
        :
        (((new Date(value.dataCadastro).toLocaleString('pt-BR').substring(0, 10) !== new Date(arr[index - 1].dataCadastro).toLocaleString('pt-BR').substring(0, 10)))) ?
          (<div key={"divprojetopai" + index}>
            <IonCard className={"card"} key={"projeto" + index}>
              <IonCardHeader key={"headerprojeto" + index}>
                <IonCardTitle key={"tituloprojeto" + index}>
                  <div key={"divprojeto" + index} className={"cabecalho"} >{new Date(value.dataCadastro).toLocaleString('pt-BR').substring(0, 10)}</div>
                </IonCardTitle>
              </IonCardHeader>
            </IonCard>
            {preencheCard(value, index)}
          </div>
          ) :
          (
            <div key={"divprojetopai" + index}>
              {preencheCard(value, index)}
            </div>
          )
    );
  }

  async function carregarProjetosSegmentadaData(filtro: any, data: any, lojasParam?: any) {
    const consultar = async () => {

      let token: string = "";
      const tkn = localStorage.getItem("token");
      if (typeof (tkn) === "string") {
        token = tkn;
      }

      console.log("valor", data);
      console.log("filtroCampoSelecionadoProjeto", filtroCampoSelecionadoProjeto);
      let valor = data;
      if (data) {
        valor = data.replaceAll(/#/g, "%23");
      }
      const resp: Response = await fetch(urlBaseCore.url + "/ordens?campo=" + (filtroCampoSelecionadoProjeto || "data") +
        "&valor=" + valor +
        "&filtro=" + filtro +
        "&lojas=" + Buffer.from(lojasParam || loja).toString('base64'),
        {
          method: urlBaseCore.method,
          headers: [
            ["token", token]
          ],
          credentials: 'include'
        });
      await resp.json().then(async (res) => {
        if (resp.status === 400 || resp.status === 401) {
          setShowLoadingPage(false);
          history.replace("/login/");
        }

        if (res && res.LastEvaluatedKey) {
          setProjetopk(res.LastEvaluatedKey.pk);
          setProjetosk(res.LastEvaluatedKey.sk);
          setProjetogsi2sk(res.LastEvaluatedKey.gsi2sk);
          setDesabilitarInfiniteScroll(false);
        }
        else {
          setDesabilitarInfiniteScroll(true);
        }

        setArrayProjetos(res.Items);
        setShowLoadingPage(false);
      });
    }
    consultar();
  }

  async function carregarMaisProjetos($event: CustomEvent<void>) {
    console.log("carregarMaisProjetos",);
    if (projetogsi2sk.includes(filtroStatusProjeto)) {
      await carregarMaisProjetosChamada().then(() => {
      });
    }
    ($event.target as HTMLIonInfiniteScrollElement).complete();
  }

  async function carregarMaisProjetosChamada() {
    let token: string = "";
    const tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") {
      token = tkn;
    }

    let valor = filtroPesquisaProjeto;
    if (filtroPesquisaProjeto) {
      valor = filtroPesquisaProjeto.replaceAll(/#/g, "%23");
    }


    console.log(valor);

    const res: Response = await fetch(urlBaseCore.url + "/ordens?campo=" + (filtroCampoSelecionadoProjeto || "data") +
      "&valor=" + valor +
      "&filtro=" + filtroStatusProjeto +
      "&isk=" + projetogsi2sk +
      "&pk=" + projetopk +
      "&sk=" + projetosk +
      "&lojas=" + Buffer.from(loja).toString('base64'),
      {
        method: urlBaseCore.method,
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
    await res
      .json()
      .then(async (projetos) => {

        if (projetos.Items) {
          for (let i = 0; i < projetos.Items.length; i++) {
            arrayProjetos.push(projetos.Items[i]);
          }

          if (projetos.LastEvaluatedKey) {
            setProjetopk(projetos.LastEvaluatedKey.pk);
            setProjetosk(projetos.LastEvaluatedKey.sk);
            setProjetogsi2sk(projetos.LastEvaluatedKey.gsi2sk);
            setDesabilitarInfiniteScroll(false);
          }
          else {
            setProjetopk("");
            setProjetosk("");
            setProjetogsi2sk("");
            setDesabilitarInfiniteScroll(true);
          }
        }

      })
      .catch(err => console.error(err));

    if (res.status === 400 || res.status === 401) history.replace("/login/");

  }

  const handleSegmentChange = (e: any) => {
    const value = e.detail.value;
    setSelectedSegment(value);
  };

  const openPopover = (e: any) => {
    popover.current!.event = e;
    setShowModalData(true);
  };

  async function closeModalEncerrar() {
    setShowEncerrar(false);
  }

  async function closeModalEncerrarSucess() {
    setShowEncerrar(false);
    carregarProjetosSegmentadaData(filtroStatusProjeto, filtroPesquisaProjeto);

  }

  async function closeModalConvidado() {
    setShowDetalhesConvidado(false);
  }

  async function closeModalSimpleConvidado() {
    setShowDetalhesConvidado(false);
  }


  async function closeModalParceria() {
    setShowDetalhesParceria(false);
    carregarProjetosSegmentadaData(filtroStatusProjeto, filtroPesquisaProjeto);
  }

  async function closeModalSimpleParceria() {
    setShowDetalhesParceria(false);
  }

  function gerarEscPos(projeto: any, imprimir58mm: any = false) {
    // Função para remover acentos e cedilhas
    function removerAcentosECedilha(texto: string): string {
      return texto
        .normalize('NFD')  // Normaliza o texto para decompô-lo em caracteres base e acentos
        .replace(/[\u0300-\u036f]/g, '')  // Remove os acentos
        .replace(/ç/g, 'c')  // Substitui 'ç' por 'c'
        .replace(/Ç/g, 'C');  // Substitui 'Ç' por 'C'
    }

    // Função para aplicar a máscara de CPF/CNPJ
    function aplicarMascaraCPFouCNPJ(texto: any) {
      if (!texto) return '';
      texto = texto.replace(/\D/g, '');
      if (texto.length === 11) {
        return texto.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      } else if (texto.length === 14) {
        return texto.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      }
      return texto;
    }

    // Função para formatar telefone
    function formataTelefone(numero: any) {
      if (numero?.length == 13) {
        let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{5})(\d{4})/);
        BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
        return BRNumber;
      }
      else if (numero?.length == 12) {
        let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{4})(\d{4})/);
        BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
        return BRNumber;
      }
      else { return "" };
    }

    function quebrarTextoEmLinhas(texto: any, tamanhoMaximo: any) {
        const conteudo = String(texto || '').trim();
        if (!conteudo) return [];

        const palavras = conteudo.split(/\s+/);
      let linhas = [];
      let linhaAtual = '';

      palavras.forEach((palavra: any) => {
          let restante = String(palavra);

          while (restante.length > 0) {
            const proximaLinha = linhaAtual ? `${linhaAtual} ${restante}` : restante;

            if (proximaLinha.length <= tamanhoMaximo) {
              linhaAtual = proximaLinha;
              restante = '';
            } else if (linhaAtual) {
              linhas.push(linhaAtual);
              linhaAtual = '';
            } else {
              linhas.push(restante.slice(0, tamanhoMaximo));
              restante = restante.slice(tamanhoMaximo);
            }
        }
      });

        if (linhaAtual) {
          linhas.push(linhaAtual);
      }

      return linhas;
    }

    // Função para formatar valores monetários
    const formatarValor = (valor: any) => {
      if (!valor) return '0,00';

      // Remove pontos de milhares e substitui a vírgula decimal por ponto
      const valorNumerico = parseFloat(valor.toString().replace(/\./g, '').replace(',', '.'));

      // Formata o número para o padrão brasileiro
      return valorNumerico.toFixed(2).replace('.', ',');
    };

    // Função para gerar o cabeçalho e as informações do cupom
    function gerarCabecalho(projeto: any, empresa: any) {
      const ESC = 0x1B;  // ESC
      const SUBLINHADO_ON = [ESC, 0x2D, 0x01];
      const SUBLINHADO_OFF = [ESC, 0x2D, 0x00];

      let cabecalhoText = "";

      // Informações da empresa
      cabecalhoText += `${empresa?.empresaNome}\n`;
      cabecalhoText += `CNPJ: ${aplicarMascaraCPFouCNPJ(empresa?.empresaCnpj)}\n`;

      // Endereço da empresa
      quebrarTextoEmLinhas(`Endereço: ${empresa.empresaEndereco}`, imprimir58mm ? 32 : 38).forEach((linha: any) => {
        cabecalhoText += `${linha}\n`;
      });

      cabecalhoText += `Tel: ${formataTelefone(empresa?.empresaTelefone)}\n`;

      // Data e hora do cupom, se disponível
      if (projeto.dataCupom) {
        cabecalhoText += `Data: ${new Date(projeto.dataCupom).toLocaleDateString('pt-BR')} Hora: ${new Date(projeto.dataCupom).toLocaleTimeString('pt-BR')}\n`;
      }

      cabecalhoText += imprimir58mm ? `********************************\n` : `**************************************\n`;

      // Informações do cliente
      cabecalhoText += `${projeto.clienteNome}\n`;

      // Se o projeto não for interno, exibe informações adicionais do cliente
      if (!projeto.interno) {
        cabecalhoText += `Tel: ${formataTelefone(projeto.clienteTelefone)}\n`;

        // Endereço do cliente, se disponível
        quebrarTextoEmLinhas(`Endereço: ${[projeto.endereco, projeto.complemento].filter(Boolean).join(', ') || ""}`, imprimir58mm ? 32 : 38).forEach((linha: any) => {
          cabecalhoText += `${linha}\n`;
        });
      }

      cabecalhoText += imprimir58mm ? `********************************\n` : `**************************************\n`;
      cabecalhoText += "CUPOM NÃO FISCAL\n";

      // Se o projeto não for interno, exibe o nome do projeto
      if (projeto.nomeProjeto) {
        cabecalhoText += imprimir58mm ? `================================\n` : `======================================\n`;
        quebrarTextoEmLinhas(`${empresa?.servicoTipo || "Projeto"}: ${projeto.nomeProjeto}`, imprimir58mm ? 32 : 38).forEach((linha: string) => {
          cabecalhoText += `${String.fromCharCode(...SUBLINHADO_ON)}${linha}${String.fromCharCode(...SUBLINHADO_OFF)}\n`;
        });
        cabecalhoText += imprimir58mm ? `================================\n` : `======================================\n`;
      }

      return cabecalhoText;
    }

    // Função para gerar o corpo do cupom (produtos)
    function gerarProdutos(projeto: any) {
      const ESC = 0x1B;  // ESC
      const SUBLINHADO_ON = [ESC, 0x2D, 0x01];
      const SUBLINHADO_OFF = [ESC, 0x2D, 0x00];

      let produtosText = "";
      const larguraProduto = imprimir58mm ? 32 : 38;

      const adicionarLinhasProduto = (
        texto: string,
        prefixoPrimeiraLinha: string,
        prefixoDemaisLinhas: string = " ".repeat(prefixoPrimeiraLinha.length),
        sublinhar: boolean = false
      ) => {
        const larguraConteudo = Math.max(8, larguraProduto - Math.max(prefixoPrimeiraLinha.length, prefixoDemaisLinhas.length));

        quebrarTextoEmLinhas(texto, larguraConteudo).forEach((linha: string, indiceLinha: number) => {
          const prefixo = indiceLinha === 0 ? prefixoPrimeiraLinha : prefixoDemaisLinhas;

          if (sublinhar) {
            produtosText += `${prefixo}${String.fromCharCode(...SUBLINHADO_ON)}${linha}${String.fromCharCode(...SUBLINHADO_OFF)}\n`;
          } else {
            produtosText += `${prefixo}${linha}\n`;
          }
        });
      };

      produtosText += "QTDE | DESCRIÇÃO\n";
      produtosText += imprimir58mm ? `--------------------------------\n` : `--------------------------------------\n`;

      if (projeto.produtos && Array.isArray(projeto.produtos) && projeto.produtos.length > 0) {
        projeto.produtos.forEach((produto: any) => {
          // Verifica se o produto possui uma descrição complexa
          if (Array.isArray(produto.descricao)) {
            produto.descricao.forEach((itemDesc: any, indexLinha: number) => {
              // Exibe a linha principal do produto apenas uma vez
              if (indexLinha === 0) {
                const prefixoPrincipal = `${produto.quantidade} | `;
                const descricaoPrincipal = produto.tipo === "pizzas"
                  ? `${produto.tamanho} ${produto.quantidadeSabores} ${produto.quantidadeSabores === 1 ? "SABOR" : "SABORES"} (R$ ${formatarValor(produto.valor)})`
                  : `${produto.categoria} (R$ ${formatarValor(produto.valor)})`;

                adicionarLinhasProduto(descricaoPrincipal, prefixoPrincipal);
              }

              // Exibe as descrições adicionais, se houver
              if (itemDesc.descricao) {
                if (itemDesc.categoria == "Observação") {
                  adicionarLinhasProduto(`Observação: ${itemDesc.descricao}`, "  ", "  ", true);
                }
                else {
                  adicionarLinhasProduto(`${itemDesc.descricao} (R$ ${formatarValor(itemDesc.valor)})`, "  - ", "    ");
                }
              }
            });
          } else {
            // Para produtos com uma única descrição simples
            adicionarLinhasProduto(`${produto.descricao} (R$ ${formatarValor(produto.valor)})`, `${produto.quantidade} | `);
          }

          // Adiciona o subtotal de cada produto
          produtosText += `VALOR: R$ ${formatarValor(produto.subtotal)}\n`;
          produtosText += imprimir58mm ? `--------------------------------\n` : `--------------------------------------\n`;
        });

        // Adiciona o total de todos os produtos
        if (projeto.valorTotalProdutos) {
          produtosText += `TOTAL: R$ ${formatarValor(projeto.valorTotalProdutos)}\n`;
        }
      }

      return produtosText;
    }

    // Função para gerar o footer com as informações de pagamento
    function gerarFooter(projeto: any, empresa: any) {
      let pagamentoText = "";
      const larguraRodape = imprimir58mm ? 32 : 38;

      const adicionarLinhasRodape = (texto: string) => {
        quebrarTextoEmLinhas(texto, larguraRodape).forEach((linha: string) => {
          pagamentoText += `${linha}\n`;
        });
      };

      const linhasFormaPagamento = Array.isArray(projeto.formaPagamento)
        ? projeto.formaPagamento
          .map((fp: any) => {
            const nome = fp?.pagamento || fp?.formaPagamentoNome || fp?.tipo;
            const valor = fp?.valor ?? fp?.formaPagamentoValor;

            if (!nome) {
              return "";
            }

            return `${String(nome).toUpperCase()}: R$ ${formatarValor(valor)}`;
          })
          .filter(Boolean)
        : [];

      if (projeto.pedidoIfood) {
        pagamentoText += imprimir58mm ? `*************iFood**************\n` : `****************iFood*****************\n`;

        if (projeto.taxas) {
          pagamentoText += `TAXAS: +R$ ${formatarValor(projeto.taxas)}\n`;
        }

        if (projeto.localizadorIfood) {
          pagamentoText += `LOCALIZADOR IFOOD: ${projeto.localizadorIfood}\n`;
        }

        if (projeto.tipoEntrega) {
          pagamentoText += `TIPO DE ENTREGA: ${projeto.tipoEntrega}\n`;
        }

        if (projeto.horarioEntrega) {
          pagamentoText += `HORÁRIO DE ENTREGA: ${projeto.horarioEntrega}\n`;
        }

        if (projeto.extraInfo) {
          adicionarLinhasRodape(`INFORMAÇÕES EXTRAS: ${projeto.extraInfo}`);
        }
      }

      if (projeto.extraInfo && !projeto.pedidoIfood && !projeto.pedido99Food) {
        adicionarLinhasRodape(`INFORMAÇÕES EXTRAS: ${projeto.extraInfo}`);
      }

      // Forma de pagamento
      if (projeto.formaPagamento) {
        if (!Array.isArray(projeto.formaPagamento)) {
          pagamentoText += imprimir58mm ? `********************************\n` : `**************************************\n`;
          const linhaPagamento = projeto.formaPagamento?.toLowerCase() === "dinheiro" && projeto.valorPagoDinheiro
            ? `DINHEIRO: R$ ${formatarValor(projeto.valorPagoDinheiro)}`
            : `FORMA PAGAMENTO: ${projeto.formaPagamento?.toUpperCase()}`;

          adicionarLinhasRodape(linhaPagamento);
        }
        else if (linhasFormaPagamento.length > 0) {
          pagamentoText += imprimir58mm ? `********************************\n` : `**************************************\n`;
          pagamentoText += `FORMAS DE PAGAMENTO:\n`;
          linhasFormaPagamento.forEach((linha: string) => adicionarLinhasRodape(linha));
        }
      }

      // Troco, se houver
      if (projeto.troco && projeto.troco !== "0,00") {
        pagamentoText += `TROCO: R$ ${formatarValor(projeto.troco)}\n`;
      }

      // Taxa de entrega, se houver
      if (projeto.taxaEntrega) {
        pagamentoText += `TAXA DE ENTREGA: +R$ ${formatarValor(projeto.taxaEntrega)}\n`;
      }

      // Desconto, se houver
      if (projeto.desconto) {
        pagamentoText += `DESCONTO: -R$ ${formatarValor(projeto.desconto)}\n`;
      }

      // Valor total, se houver
      if (projeto.valorTotal) {
        pagamentoText += imprimir58mm ? `********************************\n` : `**************************************\n`;
        pagamentoText += `TOTAL ${empresa.servicoTipo?.toUpperCase() || "PROJETO"}: R$ ${formatarValor(projeto.valorTotal)}\n`;
      }

      return pagamentoText;
    }

    function gerarQrCode(pk: string): string {
      let qrCodeText = "";

      // Comando de inicialização do QR Code
      qrCodeText += "\x1D\x28\x6B"; // Comando inicial
      qrCodeText += "\x04\x00\x31\x41\x32\x00"; // Configuração do modelo do QR (modelo 2)

      qrCodeText += "\x1D\x28\x6B"; // Tamanho dos módulos
      qrCodeText += "\x03\x00\x31\x43\x07"; // Define tamanho como 7

      // Comando para armazenar os dados
      qrCodeText += "\x1D\x28\x6B" +
        String.fromCharCode(pk.length + 3) + "\x00\x31\x50\x30" + pk;

      // Comando para imprimir o QR Code
      qrCodeText += "\x1D\x28\x6B\x03\x00\x31\x51\x30";

      return qrCodeText;
    }

    try {


      console.log("dadosImpressao1");
      // Montando o cupom com os dados no formato ESC/POS
      const cabecalho = gerarCabecalho(projeto, dadosEmpresa);

      console.log("cabecalho", cabecalho);
      const produtos = gerarProdutos(projeto);
      console.log("produtos", produtos);
      const rodape = gerarFooter(projeto, dadosEmpresa);
      console.log("rodape", rodape);
      const qrCodeGerado = gerarQrCode(projeto.pk);
      console.log("qrCodeGerado", qrCodeGerado);
      // Comandos ESC/POS básicos

      const ESC = 0x1B;  // ESC
      const LF = 0x0A;   // Line Feed
      const CORTA_PAPEL = [ESC, 0x69];   // Corta Papel
      const NEGRITO_ON = [ESC, 0x45, 0x01];  // Ativar negrito
      const NEGRITO_OFF = [ESC, 0x45, 0x00]; // Desativar negrito
      const ALIMENTAR_PAPEL = [ESC, 0x64, 0x10]; // Alimentação de papel


      const dadosImpressao: any = [
        // ...ALIMENTAR_PAPEL, // Alimentação de papel
        LF,
        ...NEGRITO_ON,
        ...removerAcentosECedilha(cabecalho).split("").map(c => c.charCodeAt(0)),
        ...NEGRITO_OFF, // Desativar negrito
        LF, // Pular linha
        ...removerAcentosECedilha(produtos).split("").map(c => c.charCodeAt(0)),
        LF, // Pular linha
        ...removerAcentosECedilha(rodape).split("").map(c => c.charCodeAt(0)),
        LF, // Pular linha
        ...qrCodeGerado.split("").map(c => c.charCodeAt(0)),
        LF, LF, LF, LF, LF,
        // ...ALIMENTAR_PAPEL, // Alimentação de papel
        ...CORTA_PAPEL

      ];

      // Retorna os dados como Uint8Array
      return new Uint8Array(dadosImpressao);
    } catch (error) {
      console.error('Erro ao imprimir cupom:', error);
      return null; // Retorna null em caso de erro
    }
  }

  const impressoraBluetoothHabilitar = () => {
    const storedValue = window.localStorage.getItem("impressoraBluetoothHabilitar");
    return storedValue === "true";
  };

  const impressoraBluetoothSPPHabilitar = () => {
    const storedValue = window.localStorage.getItem("impressoraBluetoothSPPHabilitar");
    return storedValue === "true";
  };

  const impressoraLocalHabilitar = () => {
    const storedValue = window.localStorage.getItem("impressoraLocalHabilitar");
    return storedValue === "true";
  };

  const impressoraRedeHabilitar = () => {
    const storedValue = window.localStorage.getItem("impressoraRedeHabilitar");
    return storedValue === "true";
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonButton onClick={() => {
              history.goBack();
            }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>

          <IonTitle>Histórico {(window.localStorage.getItem("servicoTipoPlural") || "Projetos")}</IonTitle>



          <IonSelect interface='popover' style={{ fontSize: "14px" }} name='Filtros' title='Filtros' value={filtroCampoSelecionadoProjeto} multiple={false} cancelText="Cancelar" okText="Ok" onIonChange={e => { trocarCampoFiltro(e); }} slot="end">
            <IonSelectOption value="data">Data</IonSelectOption>
            <IonSelectOption value="nome">Clientes</IonSelectOption>
          </IonSelect>

          <IonButton style={{ width: "170px", paddingRight: "10px" }} color="light" slot="end" size="small" hidden={filtroMostrarDataProjeto} onClick={e => { setShowModalFiltro(true); }}>
            <IonIcon style={{ "color": "#BDBDBD", paddingRight: "10px", fontSize: "12px" }} icon={search} hidden={filtroPesquisaProjeto != ""}></IonIcon>
            <IonLabel style={{ textAlign: "left", overflow: "hidden", "color": "#BDBDBD", fontSize: "12px" }}>{pesquisaNome} </IonLabel>
          </IonButton>

          <IonButton style={{ zIndex: '0', width: "170px", paddingRight: "10px" }} color="light" slot="end" size="small" hidden={!filtroMostrarDataProjeto} onClick={e => { openPopover(e); }} >
            <IonIcon style={{ "color": "#BDBDBD", paddingRight: "10px", fontSize: "12px" }} icon={search} hidden={filtroPesquisaProjeto != ""}></IonIcon>
            <IonLabel style={{ textAlign: "left", overflow: "hidden", "color": "#BDBDBD", fontSize: "12px" }}>{pesquisaData} </IonLabel>

          </IonButton>

          <IonModal isOpen={showModalFiltro} onDidDismiss={() => setShowModalFiltro(false)} >
            <AppTypeaheadItem
              title="Clientes"
              camposFiltro="nome,telefone"
              campo="nome"
              items={listaClientesFiltro}
              selectedItem={filtroPesquisaProjeto}
              onSelectionCancel={() => setShowModalFiltro(false)}
              onSelectionChange={filtroSelectionChanged}
            />
          </IonModal>
        </IonToolbar>
      </IonHeader>


      <IonContent fullscreen scrollEvents={true} ref={contentRef} color='light'>
        <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
          <IonRefresherContent></IonRefresherContent>
        </IonRefresher>

        <div className='ProjetosSlides'>
          {loadItens()}
        </div>

        <IonInfiniteScroll
          threshold="100px"
          onIonInfinite={(e: CustomEvent<void>) => carregarMaisProjetos(e)}
          position="bottom"
          disabled={desabilitarInfiniteScroll}>
          <IonInfiniteScrollContent loadingSpinner="dots" loadingText="Carregando mais itens..."></IonInfiniteScrollContent>
        </IonInfiniteScroll>
        <IonToast
          isOpen={showCopiado}
          onDidDismiss={() => setShowCopiado(false)}
          message="Campo copiado."
          duration={3000}
        />

        <div className="content">

        </div>

        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoadingPage}
          onDidDismiss={() => { setShowLoadingPage(false); }}
          spinner='circles'
        />
      </IonContent>

      <IonPopover ref={popover}
        isOpen={showModalData}
        onDidDismiss={() => setShowModalData(false)} >
        <IonDatetime
          presentation='date'
          onIonChange={e => {
            if (e.detail.value) {
              let data = e.detail.value.toString().substring(0, 10);
              const dataFormatada = new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
                Date.parse(data)
              );
              setPesquisaData(dataFormatada);
              setFiltroPesquisaProjeto(data);
              carregarProjetosSegmentadaData(filtroStatusProjeto, data);
            }
          }}></IonDatetime>

      </IonPopover >

      <IonModal onDidPresent={() => {
        if (inputConvidadosRef.current) {
          inputConvidadosRef.current.setFocus();
        }
      }} isOpen={showDetalhesConvidado} onDidDismiss={() => { setShowDetalhesConvidado(false); }}>
        {/* <Convidados projetoid={projetoId} inputRef={inputConvidadosRef} projetonome={projetoNome} empresaid={empresaId} closeAction={closeModalConvidado} closeActionSimple={closeModalSimpleConvidado}></Convidados> */}
      </IonModal>


      <IonModal isOpen={showModalServicoProduto} onDidDismiss={() => setShowModalServicoProduto(false)} initialBreakpoint={0.2} breakpoints={[0, 0.2]}>
        <IonContent className="ion-padding">
          <IonItem lines='none'>
            <IonLabel className="ion-text-wrap" style={{ marginTop: '20px', marginBottom: '10px', textAlign: 'center' }}><b>Deseja adicionar os itens agora?</b></IonLabel>
          </IonItem>
          <div style={{ marginTop: '10px', marginBottom: '10px', textAlign: 'center' }}>

            <IonChip color="primary" hidden={window.localStorage.getItem("servicoPrincipal") != "Pedidos"}
              onClick={(e) => {
                setShowModalServicoProduto(false); carregarProdutos(projetoId);
              }}>
              {/* <IonIcon icon={cube} style={{ height: "20px" }}></IonIcon> */}
              <IonLabel style={{ height: "20px" }}>Sim</IonLabel>
            </IonChip>
            <IonChip color="primary" hidden={window.localStorage.getItem("servicoPrincipal") == "Pedidos"}
              onClick={(e) => {
                setShowModalServicoProduto(false); carregarServicos(projetoId);
              }}>
              {/* <IonIcon icon={construct}></IonIcon> */}
              <IonLabel style={{ height: "20px" }}>Sim</IonLabel>
            </IonChip>

            <IonChip color="primary"
              onClick={(e) => {
                setShowModalServicoProduto(false);
              }}>
              {/* <IonIcon icon={construct}></IonIcon> */}
              <IonLabel style={{ height: "20px" }}>Não</IonLabel>
            </IonChip>


          </div>
        </IonContent>
      </IonModal>

    </IonPage>
  );
};

export default OrdensHistorico;
